import { LockableEventEmitter } from './LockableEventEmitter';
import type { EVENT } from './types';

export class AppEventEmitter extends LockableEventEmitter<EVENT> {
  private static _instance: AppEventEmitter;

  public static get Instance(): AppEventEmitter {
    const instance =
      AppEventEmitter._instance ||
      // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
      (AppEventEmitter._instance = new AppEventEmitter());

    // set maxListeners to max tile size
    instance.setMaxListeners(99);

    return instance;
  }

  /**
   * Adds the @listener function to the end of the listeners array for the event named @eventName
   * Will ensure that the @listener is added only once.
   *
   * @param {EVENT} eventName
   * @param {function} listener
   */
  addListener(eventName: EVENT, listener: (event: unknown) => void): this {
    return this.on(eventName, listener);
  }

  /**
   * Adds the @listener function to the end of the listeners array for the event named @eventName
   * Will ensure that the @listener is added only once.
   *
   * @param {EVENT} eventName
   * @param {function} listener
   */
  on(eventName: EVENT, listener: (event: unknown) => void): this {
    this.off(eventName, listener);
    super.on(eventName, listener);
    return this;
  }
}
